import React from "react";
import UsersSelect from "../../../components/searchables/usersSelect";

const Search = () => {
  return <UsersSelect />;
};

export default Search;
